import { render } from "./PriceProvideCard.vue?vue&type=template&id=0cce2698"
import script from "./PriceProvideCard.vue?vue&type=script&lang=js"
export * from "./PriceProvideCard.vue?vue&type=script&lang=js"
script.render = render

export default script